const NET_AMOUNT_LOCK_STORAGE_KEY = 'document_editor_net_amount_locked';

export function getNetAmountLockStatus(): boolean {
    if (typeof window === 'undefined') {
        return true;
    }
    try {
        const stored = localStorage.getItem(NET_AMOUNT_LOCK_STORAGE_KEY);
        return stored === null || stored === 'true';
    } catch {
        return true;
    }
}

export function setNetAmountLockStatus(isNetAmountLocked: boolean): void {
    if (typeof window === 'undefined') {
        return;
    }
    try {
        localStorage.setItem(NET_AMOUNT_LOCK_STORAGE_KEY, isNetAmountLocked ? 'true' : 'false');
    } catch {
        return;
    }
}
